import { createBrowserRouter, RouterProvider } from "react-router";
import { Layout } from "@/components/Layout";
import LoginPage from "@/pages/Login";
import HomePage from "@/pages/Home";
import MyOrdersPage from "@/pages/MyOrders";
import OrderDetailPage from "@/pages/OrderDetail";

const router = createBrowserRouter([
  { path: "/login", element: <LoginPage /> },
  {
    element: <Layout />,
    children: [
      { path: "/", element: <HomePage /> },
      { path: "/mes-commandes", element: <MyOrdersPage /> },
      { path: "/commandes/:id", element: <OrderDetailPage /> },
      { path: "*", element: <p className="text-muted">Page introuvable.</p> },
    ],
  },
]);

export default function App() {
  return <RouterProvider router={router} />;
}
